import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './languages/en.json';
import fa from './languages/fa.json';

const resources = {
  en: { translation: en },
  fa: { translation: fa },
};

function getInitialLanguage() {
  try {
    const saved = localStorage.getItem('appLanguage');
    if (saved) return saved;
  } catch (e) {}

  const envLang =
    (import.meta && import.meta.env && import.meta.env.VITE_DEFAULT_LANGUAGE) ||
    null;
  if (envLang) return envLang;

  const nav =
    typeof navigator !== 'undefined' && navigator.language
      ? navigator.language
      : null;
  if (nav && nav.toLowerCase().startsWith('fa')) return 'fa';

  return 'en';
}

const initialLang = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: 'en',
  supportedLngs: ['en', 'fa'],
  interpolation: { escapeValue: false },
});

// keep html lang & dir in sync and persist choice
// i18n.on('languageChanged', (lng) => {
// //   try { localStorage.setItem('appLanguage', lng); } catch (e) {}
//   if (typeof document !== 'undefined') {
//     document.documentElement.lang = lng;
//     document.documentElement.dir = lng === 'fa' ? 'rtl' : 'ltr';
//   }
// });

// if (typeof document !== 'undefined') {
//   const lng = i18n.language || 'fa';
//   document.documentElement.lang = lng;
//   // document.documentElement.dir = lng === 'fa' ? 'rtl' : 'ltr';
// }

export default i18n;
export const setLanguage = (lng) => i18n.changeLanguage(lng);
export const fontClass = i18n.language === 'fa' ? 'font-azarMehr' : '';
export const dir = i18n.language === 'fa' ? 'rtl' : 'ltr';
export function renderWithPersianFont(text, fontClass) {
  if (!text) return null;
  const parts = text.split(/([\u0600-\u06FF\u0750-\u077F]+)/g);
  return parts.map((part, i) =>
    /[\u0600-\u06FF\u0750-\u077F]+/.test(part) ? (
      <span key={i} className={fontClass}>{part}</span>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}